import React from 'react';

export interface TelegramLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  username: string;
}

export const TelegramLink: React.FC<TelegramLinkProps> = ({ username, ...props }) => {
  if (!username) return null;

  return (
    <a href={`https://t.me/${username}`} target="_blank" rel="noreferrer" {...props}>
      {`@${username}`}
    </a>
  );
};
